<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <router-link
                class="btn btn-outline-primary btn-sm mr-3"
                :to="{ name: 'all-services-cn' }"
                ><i class="fa fa-chevron-left mr-2"></i
                >{{ $t("message.back") }}</router-link
              >
              <h4 class="card-title">
                {{ $t("message.contragent_search.annual_report") }}
              </h4>
            </div>
            <pdf
              v-if="search_complete"
              :user_id="0"
              :doc_additional="{ request: keyword }"
              :document="results"
              :goods="[]"
              :doc_id="0"
              source="annual-report-cn"
            ></pdf>
            <div class="card-body-">
              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4 pt-4 pb-4">
                  <span
                    :class="['bmd-form-group mb-2 d-block form-label-group']"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="keyword"
                      v-model="keyword"
                      :placeholder="$t('message.find_partner.search_keyword')"
                      autocomplete="off"
                      style="cursor: auto"
                    />
                    <label for="keyword" class="form-label-group-label">{{
                      $t("message.find_partner.search_keyword")
                    }}</label>
                  </span>
                  <button
                    :class="[
                      'btn',
                      'btn-success',
                      'btn-round',
                      'btn-sm',
                      'position-relative',
                    ]"
                    @click="searchAnnualReports"
                    id="init_search_china"
                  >
                    {{ $t("message.find_partner.search_button") }}
                  </button>
                </div>
              </div>

              <div
                v-if="!search_complete && loading"
                style="position: relative; height: 100px"
              >
                <div class="loading"></div>
              </div>

              <div v-if="search_complete" class="mt-3">
                <!-- && Object.keys(results).length>0-->
                <div
                  v-for="(result, index) in results"
                  :key="'res-an-rep-' + index"
                  class="result-block mb-3"
                >
                  <div>
                    <!-- <div class="row">
                                            <div class="col-6"><h5>{{result.basic_info.CompanyName}}</h5></div>
                                            <div class="col-6 text-right">
                                                {{result.basic_info.RegNo}}
                                            </div>
                                        </div>
                                        <hr> -->
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.BasicInfo") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="basic_info_fields"
                          :items="resultsData(result, 'BasicInfoData')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.AssetsData") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="assets_data_fields"
                          :items="resultsData(result, 'AssetsData')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.ChangeList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="change_fields"
                          :items="resultsDataList(result, 'ChangeList')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.InvestInfoList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="invest_info_fields"
                          :items="resultsDataList(result, 'InvestInfoList')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.PartnerList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="partner_fields"
                          :items="resultsDataList(result, 'PartnerList')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.ProvideAssuranceList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="provide_assurance_fields"
                          :items="
                            resultsDataList(result, 'ProvideAssuranceList')
                          "
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.StockChangeList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="stock_change_fields"
                          :items="resultsDataList(result, 'StockChangeList')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.WebSiteList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="website_fields"
                          :items="resultsDataList(result, 'WebSiteList')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{
                        $t(
                          "message.contragent_search.AdministrationLicenseList",
                        )
                      }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="administration_license_fields"
                          :items="
                            resultsDataList(result, 'AdministrationLicenseList')
                          "
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.BranchList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="branch_fields"
                          :items="resultsDataList(result, 'BranchList')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.EmployeeList") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="employee_fields"
                          :items="resultsDataList(result, 'EmployeeList')"
                        ></b-table>
                      </div>
                    </div>
                    <h5
                      class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                    >
                      {{ $t("message.contragent_search.SocialInsurance") }}
                    </h5>
                    <div class="px-4 py-3">
                      <div class="table-responsive">
                        <b-table
                          :fields="social_insurance_fields"
                          :items="resultsData(result, 'SocialInsurance')"
                        ></b-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="search_complete && Object.keys(results).length == 0"
                class="mt-3 text-center pb-3 alert"
              >
                {{ $t("message.find_partner.no_results") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "annual-report-cn",
  data() {
    return {
      search_complete: false,
      loading: false,
      keyword: "",
      results: {},
      basic_info_fields: [
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.RegNo"),
        },
        {
          key: "CompanyName",
          label: this.$t("message.contragent_search.CompanyName"),
        },
        {
          key: "CreditCode",
          label: this.$t("message.contragent_search.CreditCode"),
        },
        {
          key: "OperatorName",
          label: this.$t("message.contragent_search.OperatorName"),
        },
        {
          key: "ContactNo",
          label: this.$t("message.contragent_search.ContactNo"),
        },
        {
          key: "PostCode",
          label: this.$t("message.contragent_search.PostCode"),
        },
        {
          key: "Address",
          label: this.$t("message.contragent_search.Address"),
        },
        {
          key: "EmailAddress",
          label: this.$t("message.contragent_search.EmailAddress"),
        },
        {
          key: "IsStockRightTransfer",
          label: this.$t("message.contragent_search.IsStockRightTransfer"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.Status"),
        },
        {
          key: "HasWebSite",
          label: this.$t("message.contragent_search.HasWebSite"),
        },
        {
          key: "HasNewStockOrByStock",
          label: this.$t("message.contragent_search.HasNewStockOrByStock"),
        },
        {
          key: "EmployeeCount",
          label: this.$t("message.contragent_search.EmployeeCount"),
        },
        {
          key: "BelongTo",
          label: this.$t("message.contragent_search.BelongTo"),
        },
        {
          key: "CapitalAmount",
          label: this.$t("message.contragent_search.CapitalAmount"),
        },
        {
          key: "HasProvideAssurance",
          label: this.$t("message.contragent_search.HasProvideAssurance"),
        },
        {
          key: "OperationPlaces",
          label: this.$t("message.contragent_search.OperationPlaces"),
        },
        {
          key: "MainType",
          label: this.$t("message.contragent_search.MainType"),
        },
        {
          key: "OperationDuration",
          label: this.$t("message.contragent_search.OperationDuration"),
        },
        {
          key: "IfContentSame",
          label: this.$t("message.contragent_search.IfContentSame"),
        },
        {
          key: "DifferentContent",
          label: this.$t("message.contragent_search.DifferentContent"),
        },
        {
          key: "GeneralOperationItem",
          label: this.$t("message.contragent_search.GeneralOperationItem"),
        },
        {
          key: "ApprovedOperationItem",
          label: this.$t("message.contragent_search.ApprovedOperationItem"),
        },
      ],
      change_fields: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
        },
        {
          key: "ChangeName",
          label: this.$t("message.contragent_search.ChangeName"),
        },
        {
          key: "Before",
          label: this.$t("message.contragent_search.Before"),
        },
        {
          key: "After",
          label: this.$t("message.contragent_search.After"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ChangeDate"),
        },
      ],
      partner_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ShouldCapi"),
        },
        {
          key: "ShouldDate",
          label: this.$t("message.contragent_search.ShouldDate"),
        },
        {
          key: "ShouldType",
          label: this.$t("message.contragent_search.ShouldType"),
        },
        {
          key: "RealCapi",
          label: this.$t("message.contragent_search.RealCapi"),
        },
        {
          key: "RealDate",
          label: this.$t("message.contragent_search.RealDate"),
        },
        {
          key: "RealType",
          label: this.$t("message.contragent_search.RealType"),
        },
        { key: "Form", label: this.$t("message.contragent_search.Form") },
        {
          key: "InvestmentRatio",
          label: this.$t("message.contragent_search.InvestmentRatio"),
        },
        { key: "KeyNo", label: this.$t("message.contragent_search.KeyNo") },
      ],
      invest_info_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "RegNo", label: this.$t("message.contragent_search.RegNo") },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ShouldCapi"),
        },
        {
          key: "ShareholdingRatio",
          label: this.$t("message.contragent_search.ShareholdingRatio"),
        },
      ],
      provide_assurance_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        {
          key: "Creditor",
          label: this.$t("message.contragent_search.Creditor"),
        },
        { key: "Debtor", label: this.$t("message.contragent_search.Debtor") },
        {
          key: "CreditorCategory",
          label: this.$t("message.contragent_search.CreditorCategory"),
        },
        {
          key: "CreditorAmount",
          label: this.$t("message.contragent_search.CreditorAmount"),
        },
        {
          key: "FulfillObligation",
          label: this.$t("message.contragent_search.FulfillObligation"),
        },
        {
          key: "AssuranceDurn",
          label: this.$t("message.contragent_search.AssuranceDurn"),
        },
        {
          key: "AssuranceType",
          label: this.$t("message.contragent_search.AssuranceType"),
        },
        {
          key: "AssuranceScope",
          label: this.$t("message.contragent_search.AssuranceScope"),
        },
      ],
      stock_change_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "Before", label: this.$t("message.contragent_search.Before") },
        { key: "After", label: this.$t("message.contragent_search.After") },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ChangeDate"),
        },
      ],
      website_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Type", label: this.$t("message.contragent_search.Type") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "WebSite", label: this.$t("message.contragent_search.WebSite") },
      ],
      administration_license_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "EndDate", label: this.$t("message.contragent_search.EndDate") },
      ],
      branch_fields: [
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "RegNo", label: this.$t("message.contragent_search.RegNo") },
        { key: "Address", label: this.$t("message.contragent_search.Address") },
        {
          key: "principal",
          label: this.$t("message.contragent_search.principal"),
        },
      ],
      employee_fields: [
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "Job", label: this.$t("message.contragent_search.Job") },
        { key: "CerNo", label: this.$t("message.contragent_search.CerNo") },
        {
          key: "ScertName",
          label: this.$t("message.contragent_search.ScertName"),
        },
      ],
      assets_data_fields: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.Year"),
        },
        {
          key: "PublishDate",
          label: this.$t("message.contragent_search.PublishDate"),
        },
        {
          key: "TotalAssets",
          label: this.$t("message.contragent_search.TotalAssets"),
        },
        {
          key: "TotalOwnersEquity",
          label: this.$t("message.contragent_search.TotalOwnersEquity"),
        },
        {
          key: "GrossTradingIncome",
          label: this.$t("message.contragent_search.GrossTradingIncome"),
        },
        {
          key: "MainBusinessIncome",
          label: this.$t("message.contragent_search.MainBusinessIncome"),
        },
        {
          key: "NetProfit",
          label: this.$t("message.contragent_search.NetProfit"),
        },
        {
          key: "TotalTaxAmount",
          label: this.$t("message.contragent_search.TotalTaxAmount"),
        },
        {
          key: "TotalLiabilities",
          label: this.$t("message.contragent_search.TotalLiabilities"),
        },
        {
          key: "BankingCredit",
          label: this.$t("message.contragent_search.BankingCredit"),
        },
        {
          key: "GovernmentSubsidy",
          label: this.$t("message.contragent_search.GovernmentSubsidy"),
        },
      ],
      social_insurance_fields: [
        {
          key: "No",
        },
        {
          key: "Year",
        },
        {
          key: "PublishDate",
        },
        {
          key: "UrbanBasicIns",
          label: this.$t("message.contragent_search.UrbanBasicIns"),
        },
        {
          key: "EmployeeBasicIns",
          label: this.$t("message.contragent_search.EmployeeBasicIns"),
        },
        {
          key: "MaternityIns",
          label: this.$t("message.contragent_search.MaternityIns"),
        },
        {
          key: "UnemploymentIns",
          label: this.$t("message.contragent_search.UnemploymentIns"),
        },
        {
          key: "IndustrialInjuryIns",
          label: this.$t("message.contragent_search.IndustrialInjuryIns"),
        },
        {
          key: "EntUrbanBasicInsNum",
          label: this.$t("message.contragent_search.EntUrbanBasicInsNum"),
        },
        {
          key: "EntUnemploymentInsNum",
          label: this.$t("message.contragent_search.EntUnemploymentInsNum"),
        },
        {
          key: "EntEmployeeBasicInsNum",
          label: this.$t("message.contragent_search.EntEmployeeBasicInsNum"),
        },
        {
          key: "EntIndustrialInjuryInsNum",
          label: this.$t("message.contragent_search.EntIndustrialInjuryInsNum"),
        },
        {
          key: "EntMaternityInsNum",
          label: this.$t("message.contragent_search.EntMaternityInsNum"),
        },
        {
          key: "ActUrbanBasicInsAmount",
          label: this.$t("message.contragent_search.ActUrbanBasicInsAmount"),
        },
        {
          key: "ActUnemploymentInsAmount",
          label: this.$t("message.contragent_search.ActUnemploymentInsAmount"),
        },
        {
          key: "ActEmployeeBasicInsAmount",
          label: this.$t("message.contragent_search.ActEmployeeBasicInsAmount"),
        },
        {
          key: "ActIndustrialInjuryInsAmount",
          label: this.$t(
            "message.contragent_search.ActIndustrialInjuryInsAmount",
          ),
        },
        {
          key: "ActMaternityInsAmount",
          label: this.$t("message.contragent_search.ActMaternityInsAmount"),
        },
        {
          key: "OweUrbanBasicInsAmount",
          label: this.$t("message.contragent_search.OweUrbanBasicInsAmount"),
        },
        {
          key: "OweUnemploymentInsAmount",
          label: this.$t("message.contragent_search.OweUnemploymentInsAmount"),
        },
        {
          key: "OweIndustrialInjuryInsAmount",
          label: this.$t(
            "message.contragent_search.OweIndustrialInjuryInsAmount",
          ),
        },
        {
          key: "OweMaternityInsAmount",
          label: this.$t("message.contragent_search.OweMaternityInsAmount"),
        },
      ],
    };
  },
  methods: {
    /**
     * Translates string to current locale
     * @param {String} text
     */
    async translateText(text) {
      if (text.trim() == "") return text;
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        let result = text;
        let response = await axios.get(
          window.base +
            "/library/TranslateNext?text=" +
            text +
            "&source=zh&target=" +
            locale,
        );
        result = text + " (" + response.data.translation + ")";
        return result;
      } else {
        return text;
      }
    },
    /**
     * Translates array of string into current locale
     * @param {Object} object
     */
    async translateTextObject(object) {
      try {
        var locale = this.$i18n.locale;
        switch (locale) {
          case "cn":
            locale = "zh";
            break;
          case "en":
            locale = "en";
            break;
          case "ru":
            locale = "ru";
            break;
        }
        if (locale !== "zh") {
          let keys = Object.keys(object);
          let values = Object.values(object);
          let result = {};
          let translated = await axios.post(
            window.base +
              "/library/TranslateNextArray?source=zh&target=" +
              locale,
            values,
          );
          for (let index in keys) {
            let key = keys[index];
            try {
              result[key + "_translated"] = JSON.parse(
                translated.data[index],
              ).translation;
              result[key] = values[index];
            } catch (ee) {
              result[key] = values[index];
            }
          }
          return result;
        } else {
          return object;
        }
      } catch (e) {
        return object;
      }
    },
    async doTranslation(translatable) {
      console.log("b", { ...translatable });
      for (const [key, value] of Object.entries(translatable)) {
        if (Object.prototype.toString.call(value) === "[object Array]")
          await value.forEach(async (item, index) => {
            translatable[key][index] = await this.translateTextObject(item);
          });
        else if (typeof value === "string") {
          translatable[key] = await this.translateText(value);
        } else {
          translatable[key] = await this.translateTextObject(value);
        }
      }
      console.log("a", translatable);
      return translatable;
    },
    async translate() {
      for (let id in this.results) {
        let results = this.results[id];
        for (let i in results.results) {
          for (let k in results.results[i]) {
            let o = results.results[i][k];
            console.log(i, k);
            this.$set(
              this.results[id].results[i],
              k,
              await this.doTranslation(o),
            );
          }
        }
      }
    },
    /**
     * Gets array of data-fields from the array of Results for the fields, that are arrays of objects
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsDataList(result, field) {
      const results = [];
      console.log(result, field);
      result.results.forEach((result_) => {
        result_[field].forEach((item) => {
          results.push(item);
        });
      });
      return results;
    },
    /**
     * Gets array of data-fields from the array of Results
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsData(result, field) {
      return result.results.map((result_) => {
        return {
          ...result_[field],
          Year: result_.Year,
          PublishDate: result_.PublishDate,
          No: result_.No,
        };
      });
    },
    /**
     * Groups results by company RegNo for the output
     * @param {*} results
     */
    async groupResults(results) {
      await results.forEach(async (result) => {
        if (
          Object.keys(this.results).indexOf(result.BasicInfoData.RegNo) == -1
        ) {
          //add new company
          this.results[result.BasicInfoData.RegNo] = {
            basic_info: result.BasicInfoData,
            results: [result],
          };
          console.log("groupresults");
          console.log(this.results);
        } else {
          //add result to existing company
          this.results[result.BasicInfoData.RegNo].results.push(result);
          console.log("groupresults else");
          console.log(this.results);
        }
      });
    },
    async formatObjectTables(object, resObject, complete) {
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values).then((res) => {
          res.data.forEach((t, i) => {
            resObject[keys[i]] = JSON.parse(t).translation;
            //list.push({Key: keys[i], Translated: JSON.parse(t).translation, Original: values[i] })
          });
        });
      } else return true;
    },
    async formatArrayObjectTables(object, list, complete) {
      if (object.length > 0) {
        list = [];
        object.forEach((obj, i) => {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          return this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              translated[keys[j]] = JSON.parse(res.data[j]).translation;
            }
            list.push(translated);
          });
        });
      } else return true;
    },
    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
            "/library/TranslateNextArray?source=zh&target=" +
            locale,
          text,
        );
      }
    },
    async getTranslation(result) {
      await Promise.all(
        result.map(async (res) => {
          await this.formatObjectTables(
            res.BasicInfoData,
            res.BasicInfoData,
            this.basic_info_complete,
          );
          await this.formatObjectTables(
            res.AssetsData,
            res.AssetsData,
            this.assets_complete,
          );
          await this.formatObjectTables(
            res.SocialInsurance,
            res.SocialInsurance,
            this.social_insurance_complete,
          );
          await this.formatArrayObjectTables(
            res.ChangeList,
            res.ChangeList,
            this.change_list_complete,
          );
          await this.formatArrayObjectTables(
            res.InvestInfoList,
            res.InvestInfoList,
            this.invest_info_list_complete,
          );
          await this.formatArrayObjectTables(
            res.PartnerList,
            res.PartnerList,
            this.partner_list_complete,
          );
          await this.formatArrayObjectTables(
            res.ProvideAssuranceList,
            res.ProvideAssuranceList,
            this.provide_assurance_list_complete,
          );
          await this.formatArrayObjectTables(
            res.StockChangeList,
            res.StockChangeList,
            this.stock_change_list_complete,
          );
          await this.formatArrayObjectTables(
            res.WebSiteList,
            res.WebSiteList,
            this.web_site_list_complete,
          );
          await this.formatArrayObjectTables(
            res.AdministrationLicenseList,
            res.AdministrationLicenseList,
            this.administration_license_list_complete,
          );
          await this.formatArrayObjectTables(
            res.BranchList,
            res.BranchList,
            this.branch_list_complete,
          );
          await this.formatArrayObjectTables(
            res.EmployeeList,
            res.EmployeeList,
            this.employee_list_complete,
          );
          return true;
        }),
      );
    },
    /**
     * Searches for annual reports over API
     */
    async searchAnnualReports() {
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=213")
        .then((response) => {
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.find_partner.cn_company_info_check_alert") +
                " " +
                response.data.billing_service_price +
                " " +
                response.data.billing_service_cur,
              {
                title: this.$t("message.confirm"),
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                this.search_complete = false;
                this.loading = true;
                axios
                  .get(
                    window.base +
                      "/library/openAPIAnnualReportMockup?keyWord=" +
                      this.keyword,
                  )
                  .then((response) => {
                    var result = response.data.Result;
                    if (result == null) {
                      this.no_result = true;
                      this.search_complete = true;
                      this.loading = false;
                      return;
                    }

                    this.getTranslation(result).then((r) => {
                      this.search_complete = true;
                      this.loading = false;
                      this.no_result = false;
                      console.log("gettranslation");
                      this.groupResults(result);
                    });
                  })
                  .catch(() => {
                    this.search_complete = true;
                    this.loading = false;
                    let response = {
                      data: {
                        Status: "200",
                        Message: "【有效请求】查询成功",
                        OrderNumber: "AR2022092815571389329967",
                        Result: [
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "66597593",
                              PostCode: "100032",
                              Address: "北京市西城区西长安街86号",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "国家电网有限公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "42人",
                              EmployeeBasicIns: "42人",
                              MaternityIns: "42人",
                              UnemploymentIns: "42人",
                              IndustrialInjuryIns: "42人",
                              EntUrbanBasicInsNum: "企业选择不公示",
                              EntUnemploymentInsNum: "企业选择不公示",
                              EntEmployeeBasicInsNum: "企业选择不公示",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "企业选择不公示",
                              ActUrbanBasicInsAmount: "企业选择不公示",
                              ActUnemploymentInsAmount: "企业选择不公示",
                              ActEmployeeBasicInsAmount: "企业选择不公示",
                              ActIndustrialInjuryInsAmount: "企业选择不公示",
                              ActMaternityInsAmount: "企业选择不公示",
                              OweUrbanBasicInsAmount: "企业选择不公示",
                              OweUnemploymentInsAmount: "企业选择不公示",
                              OweEmployeeBasicInsAmount: "企业选择不公示",
                              OweIndustrialInjuryInsAmount: "企业选择不公示",
                              OweMaternityInsAmount: "企业选择不公示",
                            },
                            No: 9,
                            Year: "2021年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2022-06-09",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "66597593",
                              PostCode: "100032",
                              Address: "北京市西城区西长安街86号",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "国家电网有限公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "46人",
                              EmployeeBasicIns: "46人",
                              MaternityIns: "46人",
                              UnemploymentIns: "46人",
                              IndustrialInjuryIns: "46人",
                              EntUrbanBasicInsNum: "企业选择不公示",
                              EntUnemploymentInsNum: "企业选择不公示",
                              EntEmployeeBasicInsNum: "企业选择不公示",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "企业选择不公示",
                              ActUrbanBasicInsAmount: "企业选择不公示",
                              ActUnemploymentInsAmount: "企业选择不公示",
                              ActEmployeeBasicInsAmount: "企业选择不公示",
                              ActIndustrialInjuryInsAmount: "企业选择不公示",
                              ActMaternityInsAmount: "企业选择不公示",
                              OweUrbanBasicInsAmount: "企业选择不公示",
                              OweUnemploymentInsAmount: "企业选择不公示",
                              OweEmployeeBasicInsAmount: "企业选择不公示",
                              OweIndustrialInjuryInsAmount: "企业选择不公示",
                              OweMaternityInsAmount: "企业选择不公示",
                            },
                            No: 8,
                            Year: "2020年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2021-06-04",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "010-66597593",
                              PostCode: "100031",
                              Address: "北京市西城区西长安街86号",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "国家电网有限公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "46人",
                              EmployeeBasicIns: "46人",
                              MaternityIns: "46人",
                              UnemploymentIns: "46人",
                              IndustrialInjuryIns: "46人",
                              EntUrbanBasicInsNum: "企业选择不公示",
                              EntUnemploymentInsNum: "企业选择不公示",
                              EntEmployeeBasicInsNum: "企业选择不公示",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "企业选择不公示",
                              ActUrbanBasicInsAmount: "企业选择不公示",
                              ActUnemploymentInsAmount: "企业选择不公示",
                              ActEmployeeBasicInsAmount: "企业选择不公示",
                              ActIndustrialInjuryInsAmount: "企业选择不公示",
                              ActMaternityInsAmount: "企业选择不公示",
                              OweUrbanBasicInsAmount: "企业选择不公示",
                              OweUnemploymentInsAmount: "企业选择不公示",
                              OweEmployeeBasicInsAmount: "企业选择不公示",
                              OweIndustrialInjuryInsAmount: "企业选择不公示",
                              OweMaternityInsAmount: "企业选择不公示",
                            },
                            No: 7,
                            Year: "2019年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2020-06-02",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "66597593",
                              PostCode: "100031",
                              Address: "北京市西城区西长安街86号307室",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "国家电网有限公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "43人",
                              EmployeeBasicIns: "43人",
                              MaternityIns: "43人",
                              UnemploymentIns: "43人",
                              IndustrialInjuryIns: "43人",
                              EntUrbanBasicInsNum: "企业选择不公示",
                              EntUnemploymentInsNum: "企业选择不公示",
                              EntEmployeeBasicInsNum: "企业选择不公示",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "企业选择不公示",
                              ActUrbanBasicInsAmount: "企业选择不公示",
                              ActUnemploymentInsAmount: "企业选择不公示",
                              ActEmployeeBasicInsAmount: "企业选择不公示",
                              ActIndustrialInjuryInsAmount: "企业选择不公示",
                              ActMaternityInsAmount: "企业选择不公示",
                              OweUrbanBasicInsAmount: "企业选择不公示",
                              OweUnemploymentInsAmount: "企业选择不公示",
                              OweEmployeeBasicInsAmount: "企业选择不公示",
                              OweIndustrialInjuryInsAmount: "企业选择不公示",
                              OweMaternityInsAmount: "企业选择不公示",
                            },
                            No: 6,
                            Year: "2018年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2019-06-20",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "66597593",
                              PostCode: "100031",
                              Address: "北京市西城区西长安街86号307",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "国家电网有限公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "42人",
                              EmployeeBasicIns: "42人",
                              MaternityIns: "42人",
                              UnemploymentIns: "42人",
                              IndustrialInjuryIns: "42人",
                              EntUrbanBasicInsNum: "企业选择不公示",
                              EntUnemploymentInsNum: "企业选择不公示",
                              EntEmployeeBasicInsNum: "企业选择不公示",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "企业选择不公示",
                              ActUrbanBasicInsAmount: "企业选择不公示",
                              ActUnemploymentInsAmount: "企业选择不公示",
                              ActEmployeeBasicInsAmount: "企业选择不公示",
                              ActIndustrialInjuryInsAmount: "企业选择不公示",
                              ActMaternityInsAmount: "企业选择不公示",
                              OweUrbanBasicInsAmount: "企业选择不公示",
                              OweUnemploymentInsAmount: "企业选择不公示",
                              OweEmployeeBasicInsAmount: "企业选择不公示",
                              OweIndustrialInjuryInsAmount: "企业选择不公示",
                              OweMaternityInsAmount: "企业选择不公示",
                            },
                            No: 5,
                            Year: "2017年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2018-05-18",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "66597593",
                              PostCode: "100031",
                              Address: "北京市西城区西长安街86号307室",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "国家电网公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "37人",
                              EmployeeBasicIns: "37人",
                              MaternityIns: "37人",
                              UnemploymentIns: "37人",
                              IndustrialInjuryIns: "37人",
                              EntUrbanBasicInsNum: "企业选择不公示",
                              EntUnemploymentInsNum: "企业选择不公示",
                              EntEmployeeBasicInsNum: "企业选择不公示",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "企业选择不公示",
                              ActUrbanBasicInsAmount: "企业选择不公示",
                              ActUnemploymentInsAmount: "企业选择不公示",
                              ActEmployeeBasicInsAmount: "企业选择不公示",
                              ActIndustrialInjuryInsAmount: "企业选择不公示",
                              ActMaternityInsAmount: "企业选择不公示",
                              OweUrbanBasicInsAmount: "企业选择不公示",
                              OweUnemploymentInsAmount: "企业选择不公示",
                              OweEmployeeBasicInsAmount: "企业选择不公示",
                              OweIndustrialInjuryInsAmount: "企业选择不公示",
                              OweMaternityInsAmount: "企业选择不公示",
                            },
                            No: 4,
                            Year: "2016年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2017-06-01",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "010-66597593",
                              PostCode: "100031",
                              Address: "北京市西城区西长安街86号",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "国家电网公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "",
                              EmployeeBasicIns: "",
                              MaternityIns: "",
                              UnemploymentIns: "",
                              IndustrialInjuryIns: "",
                              EntUrbanBasicInsNum: "",
                              EntUnemploymentInsNum: "",
                              EntEmployeeBasicInsNum: "",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "",
                              ActUrbanBasicInsAmount: "",
                              ActUnemploymentInsAmount: "",
                              ActEmployeeBasicInsAmount: "",
                              ActIndustrialInjuryInsAmount: "",
                              ActMaternityInsAmount: "",
                              OweUrbanBasicInsAmount: "",
                              OweUnemploymentInsAmount: "",
                              OweEmployeeBasicInsAmount: "",
                              OweIndustrialInjuryInsAmount: "",
                              OweMaternityInsAmount: "",
                            },
                            No: 3,
                            Year: "2015年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2016-06-12",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "010-66597593",
                              PostCode: "100031",
                              Address: "北京市西城区西长安街86号",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "分公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "",
                              EmployeeBasicIns: "",
                              MaternityIns: "",
                              UnemploymentIns: "",
                              IndustrialInjuryIns: "",
                              EntUrbanBasicInsNum: "",
                              EntUnemploymentInsNum: "",
                              EntEmployeeBasicInsNum: "",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "",
                              ActUrbanBasicInsAmount: "",
                              ActUnemploymentInsAmount: "",
                              ActEmployeeBasicInsAmount: "",
                              ActIndustrialInjuryInsAmount: "",
                              ActMaternityInsAmount: "",
                              OweUrbanBasicInsAmount: "",
                              OweUnemploymentInsAmount: "",
                              OweEmployeeBasicInsAmount: "",
                              OweIndustrialInjuryInsAmount: "",
                              OweMaternityInsAmount: "",
                            },
                            No: 2,
                            Year: "2014年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2015-03-11",
                          },
                          {
                            BasicInfoData: {
                              RegNo: "110102014746161",
                              CompanyName: "国家电网公司国际业务服务分公司",
                              CreditCode: "91110102593859063A",
                              OperatorName: "",
                              ContactNo: "010-66597593",
                              PostCode: "100031",
                              Address: "北京市西城区西长安街86号",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              IsStockRightTransfer: "否",
                              Status: "开业",
                              HasWebSite: "否",
                              HasNewStockOrByStock: "否",
                              EmployeeCount: "企业选择不公示",
                              BelongTo: "分公司",
                              CapitalAmount: "",
                              HasProvideAssurance: "否",
                              OperationPlaces: "",
                              MainType: "",
                              OperationDuration: "",
                              IfContentSame: "",
                              DifferentContent: "",
                              GeneralOperationItem: "",
                              ApprovedOperationItem: "",
                            },
                            AssetsData: {
                              TotalAssets: "企业选择不公示",
                              TotalOwnersEquity: "企业选择不公示",
                              GrossTradingIncome: "企业选择不公示",
                              TotalProfit: "企业选择不公示",
                              MainBusinessIncome: "企业选择不公示",
                              NetProfit: "企业选择不公示",
                              TotalTaxAmount: "企业选择不公示",
                              TotalLiabilities: "企业选择不公示",
                              BankingCredit: "",
                              GovernmentSubsidy: "",
                            },
                            ChangeList: [],
                            InvestInfoList: [],
                            PartnerList: [],
                            ProvideAssuranceList: [],
                            StockChangeList: [],
                            WebSiteList: [],
                            AdministrationLicenseList: [],
                            BranchList: [],
                            EmployeeList: [],
                            SocialInsurance: {
                              UrbanBasicIns: "",
                              EmployeeBasicIns: "",
                              MaternityIns: "",
                              UnemploymentIns: "",
                              IndustrialInjuryIns: "",
                              EntUrbanBasicInsNum: "",
                              EntUnemploymentInsNum: "",
                              EntEmployeeBasicInsNum: "",
                              EntIndustrialInjuryInsNum: "",
                              EntMaternityInsNum: "",
                              ActUrbanBasicInsAmount: "",
                              ActUnemploymentInsAmount: "",
                              ActEmployeeBasicInsAmount: "",
                              ActIndustrialInjuryInsAmount: "",
                              ActMaternityInsAmount: "",
                              OweUrbanBasicInsAmount: "",
                              OweUnemploymentInsAmount: "",
                              OweEmployeeBasicInsAmount: "",
                              OweIndustrialInjuryInsAmount: "",
                              OweMaternityInsAmount: "",
                            },
                            No: 1,
                            Year: "2013年度报告",
                            Remarks: "",
                            HasDetailInfo: "True",
                            PublishDate: "2015-03-11",
                          },
                        ],
                      },
                    };
                    console.log("gettranslation catch");

                    this.groupResults(response.data.Result);
                    // this.translate()
                  });
              }
            });
        });
    },
  },
};
</script>
